export const joinPaths = (...parts: string[]): string => {
  const joined = parts
    .filter(Boolean) // drop empty/undefined
    .join('/');

  // Collapse multiple slashes, handle ., ..
  const segments = joined.split('/');

  const out = [];
  for (const seg of segments) {
    if (!seg || seg === '.') {
      // eslint-disable-next-line no-continue
      continue;
    }
    if (seg === '..') {
      if (out.length && out[out.length - 1] !== '..') {
        out.pop();
      } else {
        out.push('..');
      }
    } else {
      out.push(seg);
    }
  }

  // Preserve leading slash if first part was absolute
  const leadingSlash = joined.startsWith('/');
  return (leadingSlash ? '/' : '') + out.join('/');
};
